export default [
  {
    name: 'debrief-detailed-report',
    path: '/reports/debrief/detailed',
    component: () => import('@/views/reports/history/debrief-detailed/DebriefDetailedReport')
  },
  {
    name: 'debrief-detailed-schedule',
    path: '/reports/debrief/detailed/schedule',
    component: () => import('@/views/reports/history/debrief-detailed/DebriefDetailedSchedule')
  },
  {
    name: 'debrief-summary-report',
    path: '/reports/debrief/summary',
    component: () => import('@/views/reports/history/debrief-summary/DebriefSummaryReport')
  },
  {
    name: 'debrief-summary-schedule',
    path: '/reports/debrief/summary/schedule',
    component: () => import('@/views/reports/history/debrief-summary/DebriefSummarySchedule')
  },
  {
    name: 'vehicle-analysis-report',
    path: '/reports/vehicle/analysis',
    component: () => import('@/views/reports/history/vehicle-analysis/VehicleAnalysisReport')
  },
  {
    name: 'vehicle-analysis-schedule',
    path: '/reports/vehicle/analysis/schedule',
    component: () => import('@/views/reports/history/vehicle-analysis/VehicleAnalysisSchedule')
  },
  {
    name: 'vehicle-maintenance-report',
    path: '/reports/vehicle/maintenance',
    component: () => import('@/views/reports/management/vehicle-maintenance/VehicleMaintenanceReport')
  },
  {
    name: 'vehicle-maintenance-schedule',
    path: '/reports/vehicle/maintenance/schedule',
    component: () => import('@/views/reports/management/vehicle-maintenance/VehicleMaintenanceSchedule')
  },
  {
    name: 'speeding-detailed-report',
    path: '/reports/vehicle/speeding/detailed',
    component: () => import('@/views/reports/history/vehicle-speeding-detailed/VehicleSpeedingDetailedReport')
  },
  {
    name: 'speeding-detailed-schedule',
    path: '/reports/vehicle/speeding/detailed/schedule',
    component: () => import('@/views/reports/history/vehicle-speeding-detailed/VehicleSpeedingDetailedSchedule')
  },
  {
    name: 'speeding-summary-report',
    path: '/reports/vehicle/speeding/summary',
    component: () => import('@/views/reports/history/vehicle-speeding-summary/VehicleSpeedingSummaryReport')
  },
  {
    name: 'speeding-summary-schedule',
    path: '/reports/vehicle/speeding/summary/schedule',
    component: () => import('@/views/reports/history/vehicle-speeding-summary/VehicleSpeedingSummarySchedule')
  },
  {
    name: 'position-log-schedule',
    path: '/reports/position/log/schedule',
    component: () => import('@/views/reports/history/pos-log/PositionLogSchedule')
  },
  {
    name: 'position-log-report',
    path: '/reports/position/log',
    component: () => import('@/views/reports/history/pos-log/PositionLogReport')
  },
  {
    name: 'expenses-report',
    path: '/reports/vehicle/expenditure',
    component: () => import('@/views/reports/expenses/ExpensesReport')
  },
  {
    name: 'expenses-schedule',
    path: '/reports/vehicle/expenditure/schedule',
    component: () => import('@/views/reports/expenses/ExpenseSchedule')
  },
  {
    name: 'detailed-events-report',
    path: '/reports/events/detailed',
    component: () => import('@/views/reports/history/event-detailed/DetailedEventReport')
  },
  {
    name: 'detailed-events-schedule',
    path: '/reports/events/detailed/schedule',
    component: () => import('@/views/reports/history/event-detailed/DetailedEventSchedule')
  },
  {
    name: 'events-summary-report',
    path: '/reports/events/summary',
    component: () => import('@/views/reports/history/event-summary/EventSummaryReport')
  },
  {
    name: 'events-summary-schedule',
    path: '/reports/events/summary/schedule',
    component: () => import('@/views/reports/history/event-summary/EventSummarySchedule')
  },
  {
    name: 'status-units-detailed-report',
    path: '/reports/status/units/detailed',
    component: () => import('@/views/reports/status/units-detailed/UnitStatusDetailedReport')
  },
  {
    name: 'status-units-detailed-schedule',
    path: '/reports/status/units/detailed/schedule',
    component: () => import('@/views/reports/status/common/UnitStatusSchedule')
  },
  {
    name: 'status-units-summary-report',
    path: '/reports/status/units/summary',
    component: () => import('@/views/reports/status/units-summary/UnitStatusSummaryReport')
  },
  {
    name: 'status-units-summary-schedule',
    path: '/reports/status/units/summary/schedule',
    component: () => import('@/views/reports/status/common/UnitStatusSchedule')
  },
  {
    name: 'events-pool-detailed-report',
    path: '/reports/events/pool/detailed',
    component: () => import('@/views/reports/event-pools/EventPoolReport')
  },
  {
    name: 'events-pool-detailed-schedule',
    path: '/reports/events/pool/detailed/schedule',
    component: () => import('@/views/reports/event-pools/EventPoolSchedule')
  },
  {
    name: 'events-pool-summary-report',
    path: '/reports/events/pool/summary',
    component: () => import('@/views/reports/event-pools/EventPoolReport')
  },
  {
    name: 'events-pool-summary-schedule',
    path: '/reports/events/pool/summary/schedule',
    component: () => import('@/views/reports/event-pools/EventPoolSchedule')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeReports.js